import { RootState } from "@/utils/store";
import createCachedSelector from "re-reselect";

export const selectTeamSelectedChannels = createCachedSelector(
  (rootState: RootState) => rootState.teams,
  (_: RootState["teams"], teamId: string) => teamId,
  (teams, teamId) =>
    teamId ? teams[teamId]?.selectedChannels?.sort() || [] : []
)((_, teamId) => teamId);

export const selectTeamSettings = createCachedSelector(
  (rootState: RootState) => rootState.teams,
  (_: RootState["teams"], teamId: string) => teamId,
  (teams, teamId) => teams[teamId]?.settings
)((_, teamId) => teamId);

export const selectTeam = createCachedSelector(
  (rootState: RootState) => rootState.teams,
  (_: RootState["teams"], teamId: string) => teamId,
  (teams, teamId) => teams[teamId]
)((_, teamId) => teamId);

export const selectTeamTestingProperties = createCachedSelector(
  (rootState: RootState) => rootState.teams,
  (_: RootState["teams"], teamId: string) => teamId,
  (teams, teamId) => ({
    testingSettings: teams[teamId]?.testingSettings,
    testingChannels: teams[teamId]?.testingChannels,
    eytvTestingAudience: teams[teamId]?.eytv_testing_audience,
    eytvTestingGaAccountId: teams[teamId]?.eytv_testing_ga_account_id,
    eytvTestingAudienceSegment: teams[teamId]?.eytv_testing_audience_segment,
    isEytvEnabled: teams[teamId]?.is_eytv_enabled,
  })
)((_, teamId) => teamId);

export const selectDistributionChannelsFilter = createCachedSelector(
  (rootState: RootState) => rootState.distribution.projectsChannelsFilter,
  (_: RootState["distribution"]["projectsChannelsFilter"], teamId: string) =>
    teamId,
  (projectsChannelsFilter, teamId) => projectsChannelsFilter[teamId]
)((_, teamId) => teamId);
